import { render, staticRenderFns } from "./storPerformance.vue?vue&type=template&id=806ec04c&scoped=true&"
import script from "./storPerformance.vue?vue&type=script&lang=js&"
export * from "./storPerformance.vue?vue&type=script&lang=js&"
import style0 from "./storPerformance.vue?vue&type=style&index=0&id=806ec04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806ec04c",
  null
  
)

export default component.exports